import { render, staticRenderFns } from "./enter.vue?vue&type=template&id=20f42d0f&scoped=true"
import script from "./enter.vue?vue&type=script&lang=js"
export * from "./enter.vue?vue&type=script&lang=js"
import style0 from "./enter.vue?vue&type=style&index=0&id=20f42d0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f42d0f",
  null
  
)

export default component.exports